import i18n from '../i18n';

/**
 * Convierte un error de la API en un mensaje para la persona, en su idioma.
 *
 * El backend responde en inglés, pero cada error trae un código
 * (`INVALID_CREDENTIALS`, `LIMIT_REACHED`, …). Traducimos por código y dejamos
 * el texto del servidor solo como último recurso, para que un caso que todavía
 * no hemos traducido siga diciendo algo útil en lugar de un genérico.
 *
 *   notify.error(mensajeDeError(error, t('stores.connect_failed')));
 */
export function mensajeDeError(error, respaldo) {
    const data = error?.response?.data;

    // 1. Código conocido: la traducción manda sobre el texto en inglés.
    // `detalle` lo manda el servidor cuando hay un dato que la frase necesita
    // —el nombre exacto con el que Shopify se negó, por ejemplo— y que en un 5xx
    // no llegaría de otro modo, porque el mensaje se oculta en producción.
    const codigo = data?.error?.code;
    if (codigo) {
        // Sin `detalle` —un servidor anterior a este cambio, mientras dura el
        // relevo entre los dos despliegues— la frase no puede quedar cortada en
        // «Motivo que dio Shopify: »: se dice que no vino.
        const traducido = i18n.t(`errores.${codigo}`, {
            defaultValue: '',
            detalle: data?.error?.detalle || i18n.t('errores.detalle_no_indicado')
        });
        if (traducido) return traducido;
    }

    // 2. Errores de validación de express-validator.
    //
    // Algunos traen un código en vez de una frase —`PASSWORD_CORTA`,
    // `PASSWORD_CONOCIDA`— porque la regla vive en el servidor y el texto que
    // lee la persona vive aquí, en su idioma. Si hay traducción, manda.
    if (Array.isArray(data?.errors) && data.errors[0]?.msg) {
        const msg = data.errors[0].msg;
        const traducido = i18n.t(`errores.${msg}`, { defaultValue: '' });
        return traducido || msg;
    }

    // 3. El limitador de peticiones responde con `error` como cadena suelta.
    if (typeof data?.error === 'string') return data.error;

    // 4. Texto del servidor, aunque venga en inglés: dice más que un genérico.
    //    Salvo el mensaje que fabrica axios ("Request failed with status code
    //    400"), que no explica nada y tapaba el respaldo de la pantalla.
    const generico = /^Request failed with status code/i;
    const delServidor = data?.error?.message || data?.message;
    if (delServidor && !generico.test(delServidor)) return delServidor;

    // 5. Ni siquiera hubo respuesta: el servidor no contestó.
    if (!error?.response) return i18n.t('errores.SIN_RESPUESTA');

    return respaldo || i18n.t('errores.SERVER_ERROR');
}

export default mensajeDeError;
